import { Injectable } from '@angular/core';
import { variantUrlFragments } from '@app/helpers';
import { Converter, Occ, Product } from 'haba-core';
@Injectable()
export class CustomProductNormalizer implements Converter<Occ.Product, Product> {
  convert(source: Occ.Product, target?: Product): Product {
    if (source.url) {
      const { fragment, url } = variantUrlFragments(source.url);
      target.customProductUrl = url.split('/')[2];
      target.customProductUrlFragment = fragment;
    }
    return target;
  }
}
